import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { useNativeBridge } from 'src/contexts/NativeBridgeContext';


interface Props {
  forceClose?: boolean;
}
export const WebviewBackButton: React.FC<Props> = ({ forceClose = false }) => {
  const {
    isWebview,
    postMessage,
    closeable,
    supportsNativeDrawerToggle,
    toggleNativeDrawer,
  } = useNativeBridge();
  const navigate = useNavigate();
  const location = useLocation();

  const isFirstPage = () => {
    // Check if it's the default history entry OR a base route
    const baseRoutes = [
      '/clients/',
      '/embed/dashboard/',
      '/appointments/',
      '/messages/',
    ];
    return location.key === 'default' || baseRoutes.includes(location.pathname);
  };

  const useHamburger = supportsNativeDrawerToggle() && isFirstPage();

  const handleBackClick = () => {
    if (useHamburger) {
      toggleNativeDrawer();
    } else {
      if (isFirstPage() || forceClose) {
        postMessage('close'); // Close the window
      } else {
        navigate(-1); // Go back in history
      }
    }
  };

  const backIcon = useHamburger ? (
    <Icon icon={faBars} />
  ) : (
    <Icon icon={faChevronLeft} />
  );

  if (!isWebview) return null;
  if (isFirstPage() && !closeable && !supportsNativeDrawerToggle) return null;

  return (
    <IconButton onClick={handleBackClick} sx={{ mr: 0 }}>
      {backIcon}
    </IconButton>
  );
};
